import React from "react";

interface ITableFlexContainerProps {
  minHeight?: string;
  maxHeight?: string;
  children: React.ReactNode;
}

const defaultMinHeight = "240px";

const TableFlexContainer = ({
  minHeight = defaultMinHeight,
  maxHeight,
  children,
}: ITableFlexContainerProps) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  // Set the max height of the container to the height of the content using ResizeObserver
  // and requestAnimationFrame to ensure the layout is updated correctly.
  // Observer is used to fix  the issue "ResizeObserver loop completed with undelivered notifications."
  // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver#observation_errors

  React.useEffect(() => {
    const target = containerRef.current;

    const observer = new ResizeObserver(entries => {
      requestAnimationFrame(() => {
        for (const entry of entries) {
          if (entry.contentRect.height >= 0) {
            if (containerRef.current?.style) {
              containerRef.current.style.maxHeight =
                entry.contentBoxSize[0].blockSize + 10 + "px";
            }
          }
        }
      });
    });

    if (target) {
      observer.observe(target);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div style={{ position: "relative" }} ref={containerRef}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight,
          minHeight,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default TableFlexContainer;
